import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallerTypePipe } from './caller-type.pipe';

@NgModule({
  declarations: [CallerTypePipe],
  imports: [CommonModule],
  exports: [CallerTypePipe],
})
export class CallerTypePipeModule {}
